/**
 * Tiny localStorage helpers for "have I used my Edge today?" — drives
 * the small completion check on the YourEdgeToday card.
 *
 * Storage keys are namespaced and carry the local YYYY-MM-DD so a new
 * day silently resets the streak.
 */

const KEY = "reclaim_edge_used_dates";

function todayStamp() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

export function getEdgeUsedDates() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function hasUsedEdgeToday() {
  return getEdgeUsedDates().includes(todayStamp());
}

export function markEdgeUsedToday() {
  try {
    const dates = new Set(getEdgeUsedDates());
    dates.add(todayStamp());
    // Cap at the most recent 60 entries to keep storage tiny.
    const arr = Array.from(dates).sort().slice(-60);
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch (_) {}
}

export function getEdgeStreakDays() {
  const set = new Set(getEdgeUsedDates());
  let streak = 0;
  const d = new Date();
  // Walk back day-by-day until we find a missing day.
  // (User has to use today OR yesterday to show a streak ≥ 1.)
  // Allow yesterday to count today if not used yet.
  for (let i = 0; i < 365; i++) {
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const stamp = `${d.getFullYear()}-${m}-${day}`;
    if (set.has(stamp)) streak++;
    else if (i > 0) break; // missing past day breaks streak
    d.setDate(d.getDate() - 1);
  }
  return streak;
}
